/**
 * Cognitoの誕生日属性をyyyy-mm-dd形式に変換する。mmとddは2桁になるように0埋めする。
 * @param {string} birthday yyyy-mm-dd
 * @returns {string} yyyy-mm-dd
 */
const convertBirthday = (birthday) => {
    if (!birthday) {
        return "";
    }
    const birthDayParams = birthday.split("-");
    if (birthDayParams.length !== 3) {
        return "";
    }
    const birthMonth = birthDayParams[1].toString().padStart(2, "0");
    const birthDay = birthDayParams[2].toString().padStart(2, "0");
    const birthYear = birthDayParams[0];
    return `${birthYear}-${birthMonth}-${birthDay}`;
}

export default convertBirthday;
